import { Button } from '@workingclock/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { CodeWindow, CommandLine, OutputLine } from '../developers/code-window';
import { Container } from '../layout/container';

/**
 * Teases the developers page (CLI + MCP). Replaces the former early-access
 * teaser: it shows something concrete the product actually does — track time
 * from the terminal and from an AI agent — instead of a "we're early" note.
 */
export function DevelopersTeaser() {
  const { t } = useTranslation('marketing');

  return (
    <section className="border-b border-border py-16 md:py-24">
      <Container className="grid items-center gap-10 md:grid-cols-2">
        <div>
          <h2 className="text-headline text-ink">{t('home.developers.heading')}</h2>
          <p className="mt-4 max-w-[55ch] text-body text-muted">{t('home.developers.body')}</p>
          <Button variant="secondary" asChild className="mt-6">
            <Link to="/developers">{t('home.developers.cta')}</Link>
          </Button>
        </div>

        <CodeWindow title="zsh" className="mx-auto w-full max-w-md">
          <CommandLine>workingclock start --project &quot;Website redesign&quot;</CommandLine>
          <OutputLine>Started at 09:14:02.</OutputLine>
          {'\n'}
          <OutputLine className="text-muted">
            {t('home.developers.mcpComment')}
          </OutputLine>
          <OutputLine className="text-ink">
            <span className="text-gold">▶</span> {t('home.developers.mcpPrompt')}
          </OutputLine>
        </CodeWindow>
      </Container>
    </section>
  );
}
